import { Modal } from "react-bootstrap";
import { useState } from "react";
import Button from "../Button";

const convertToHtml = (data) => {
    return <div className="common-success-message" dangerouslySetInnerHTML={{ __html: data }}></div>
}
export default function CommonPopUpModal(props) {
    const {
        height,
        color,
        header,
        content,
        showModal,
        icon,
        handleClose,
        btnText,
        btnPosition,
        btnColor
    } = props
    const [showPop, setShow] = useState(showModal)
    return (
        <Modal
            show={showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            className="z-index-popup-transition"
            backdropClassName="z-index-popup-transition-backdrop"
            scrollable={true}
        >
            <div>
                <div className="popup-cancel-btn-wrapper">
                    <div className="gen-ai-common-popup__icon-area" onClick={(e) => { setShow(false); handleClose(false) }} aria-hidden="true">
                        <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <div style={{ padding: "0 5%" }}>
                    <Modal.Header style={{ justifyContent: "center", borderBottomColor: color }}>
                        <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                                {icon ?
                                    <div>
                                        <img src={icon} alt="" className="popup-header-icon-wrapper" />
                                    </div>
                                    :
                                    <div className="popup-header-icon-wrapper"></div>}
                                <span style={{ color: color }}>{header}</span>
                            </Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body scrollable={true} style={{ height: height }}>
                        <div style={{ textAlign: "center" }}>
                            {convertToHtml(content)}
                        </div>
                    </Modal.Body>
                    <div style={{ textAlign: btnPosition, padding: "3% 0" }}>
                        <Button text={btnText} customColor={btnColor} action={() => { setShow(false); handleClose(false) }} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}